import React from "react";
import { isMobileNativeApp } from '../../utils/mobileAppCheck';
import { getHeaderStatus } from "../../utils/is.after";


export class YourLoanDetails extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      showDiv: true,
      isHeaderShow: isMobileNativeApp() || getHeaderStatus(props.offerPreFilled.channelSource)
    };
  }

  changeShowDiv = () => {
    let prevState = this.state.showDiv;
    this.setState({ showDiv: !prevState });
    if (this.props.handleExpandCollapseLoanDetailsSelection) {
      this.props.handleExpandCollapseLoanDetailsSelection(!prevState);
    }
  };

  showLoanDetails = () => {
    if (this.props.handleExpandCollapseLoanDetailsSelection) {
      if (this.state.isHeaderShow === false) {
        return true;
      }
      let doShow = this.props.displayLoanDetails;
      let prevState = this.state.showDiv;
      if ((this.props.displayLoanDetails === false && prevState === true)
          || (this.props.displayLoanDetails === true && prevState === false)) {
        this.setState({ showDiv: !prevState });
      }
      return doShow;
    } else {
      return this.state.showDiv;
    }
  };

    render = () => {
      const { showDiv } = this.state;
      const { crossSellPersonalizedQuote, rewardEnabled, rewardEarn } = this.props.offerPreFilled;
      let { rewardDisplayCurrency, currencyPrefix } = this.props.offerPreFilled;
      const status = 'Under review'; //this.props.offerPreFilled.status;
      const showStatus = this.props.showStatus;
      if(rewardEnabled){
        if(!rewardDisplayCurrency){
          rewardDisplayCurrency=rewardEarn.clRewardCurrency;
        }
        if(currencyPrefix===undefined){
          currencyPrefix=rewardEarn.currencyPrefix;
        }
      }
      let statusRow;
      const statusInfo = (status==='PENDING' || status==='Under review') ?"status-red-icon":"";
      const showRepeatPayments = this.props.showRepeatPayments;
      let repeatPaymentsInfo;
      if(showRepeatPayments){
        let isEnroll = this.props.offerPreFilled.loanBankInfo.isAutoPayEnrollEnabled;
        repeatPaymentsInfo=(
          <div className="col-xs-12">
            <div className="row loan-details-row">
              <div className="col-7 your-loan-details loan-details-title">AutoPay</div>
              <div className="col-5 your-loan-light-grey loan-details-text">
                {isEnroll?"Enrolled":"Not enrolled" }
              </div>
            </div>
          </div>
        );
      }
      if(status && showStatus){
        statusRow =(
          <div className="col-xs-12">
            <div className="row loan-details-row">
              <div className="your-loan-details col-7 loan-details-title">Status</div>
              <div className="col-5 your-loan-light-grey loan-details-text">
                <span className="status-red-icon"></span>
                {status}
              </div>
            </div>
          </div>
        );
      }
      return (
        <section className="section-width  col-sm-12 col-lg-12 col-md-12 col-xs-12 border-round">
          <div className="loan-details width-100">
            <div className="loan-details-section loan-details-list">
              <div className="standard-blue loan-details-margin summary-hidden-xs text-center ">
                <span className="your-loan-title font-weight-400">Loan summary</span>
              </div>
              <div className="standard-blue loan-details-margin summary-visible-xs" onClick={this.changeShowDiv}>
                <div className={this.state.showDiv? 'arrow-down arrow-loan arrow-left' : 'arrow-right arrow-right-loan arrow-left'} />
                <span className="your-loan-title font-weight-400">Loan summary</span>
              </div>
              { this.showLoanDetails()
              && (
                <div className="">
                  {statusRow}
                  <div className="col-xs-12">
                    <div className="row loan-details-row">
                      <div className="your-loan-details col-7 loan-details-title">Loan amount</div>
                      <div className="col-5 your-loan-light-grey loan-details-text">
                      ${new Intl.NumberFormat().format(crossSellPersonalizedQuote.loanAmount)}
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="row loan-details-row">
                      <div className="your-loan-details col-7 loan-details-title">Monthly due</div>
                      <div className="col-5 your-loan-light-grey loan-details-text">
                                        ${crossSellPersonalizedQuote.monthlyPayment}
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="row loan-details-row">
                      <span className="your-loan-details col-7 loan-details-title">APR</span>
                      <span className="col-5 your-loan-light-grey loan-details-text">
                        {crossSellPersonalizedQuote.apr}%
                      </span>
                    </div>
                  </div>
                </div>
              )}
              { this.showLoanDetails()
              && (
                <div>
                  <div className="col-xs-12">
                    <div className="row loan-details-row">
                      <div className="col-7 your-loan-details loan-details-title">Term</div>
                      <div className="col-5 your-loan-light-grey loan-details-text">
                        {crossSellPersonalizedQuote.termInMonths} months
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="row loan-details-row">
                      <div className="col-7 your-loan-details loan-details-title">
                        First payment
                        <p className="your-loan-light-grey font-size-14 your-loan-payment-txt">This is the day your payments will be due each month.
                          Your payment due date can be modified in the Loan Servicing site.</p>
                      </div>
                      <div className="col-5 your-loan-light-grey loan-details-text your-loan-payment-date">{crossSellPersonalizedQuote.paymentDueDate}</div>
                    </div>
                  </div>
                  {

                    (crossSellPersonalizedQuote.totalReward&&rewardEnabled)
                      ?
                      <div className="col-xs-12">
                        <div className="row loan-details-row">
                          <div className="col-7 your-loan-details loan-details-title">Total rewards</div>
                          <div className="col-5 your-loan-light-grey loan-details-text">
                            <span>{currencyPrefix}{new Intl.NumberFormat().format(crossSellPersonalizedQuote.totalReward.value)}</span> <span className="rewards-value-span">{rewardDisplayCurrency}</span>
                          </div>
                        </div>
                      </div>
                      : null
                  }
                  {repeatPaymentsInfo}
                </div>
              )}
            </div>
          </div>
        </section>
      );
    }
}
export default YourLoanDetails;
